import { Col, Row, Skeleton } from "antd";
import styles from "./Budget.module.css";
import {
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import { useState } from "react";
import Modal from "../../../../components/modal/Modal";
import Dropdown from "../../../../components/dropdowns/Dropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import {
  priceFormat,
  showAlert,
} from "../../../../Store/Actions/GeneralActions";
import ProgressBar from "@ramonak/react-progress-bar";
import { BiEdit } from "react-icons/bi";
import { MdDelete } from "react-icons/md";

const WalletIcon = () => {
  return (
    <svg
      //   width="132"
      //   height="173"
      className={styles.icon}
      viewBox="0 0 132 173"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_58_14672)">
        <path
          d="M85.1001 131.186C85.1001 141.65 85.1405 152.114 85.0798 162.578C85.0596 166.326 85.0798 171.026 80.9444 171.988C77.8605 172.708 73.4621 171.593 70.813 169.689C51.8344 155.973 32.9569 142.106 14.4636 127.742C5.55566 120.824 0.853981 110.998 0.732647 99.572C0.510202 78.9786 0.500091 58.3852 0.84387 37.802C0.894425 34.4997 2.38076 30.1643 4.76699 28.2194C8.07334 25.5148 12.0875 28.0269 15.3028 30.4276C33.6748 44.1127 52.1782 57.6357 70.3681 71.5739C79.8119 78.8064 84.8372 88.7841 85.0798 100.818C85.2618 110.927 85.1001 121.057 85.1001 131.186Z"
          className={styles.iconPath}
        />
        <path
          d="M103.099 51.5476C93.1803 37.3763 84.1308 24.4611 74.7578 11.0698C65.9206 17.2489 57.2756 23.2861 48.6306 29.3436C38.024 36.7685 38.024 36.7685 27.8016 28.6142C27.3365 28.2496 26.9219 27.814 26.4062 27.348C26.9826 26.9834 27.2657 26.6592 27.478 26.6896C36.6084 28.3306 43.484 23.8635 50.3494 18.6974C58.8024 12.3664 67.6193 6.52166 76.6384 0.210938C81.9266 7.72707 87.2754 14.8482 92.0478 22.344C94.2723 25.8489 96.8304 26.8314 100.703 26.6896C107.427 26.4262 114.171 26.5782 120.905 26.6288C128.266 26.6896 131.512 29.7893 131.532 37.0015C131.582 64.6654 131.582 92.3292 131.532 119.993C131.522 127.246 128.61 130.224 121.532 130.295C112.634 130.386 103.726 130.315 94.4138 130.315C92.7758 110.502 98.5291 89.7259 83.0792 71.756C90.3795 71.756 96.3248 71.756 102.28 71.756C104.131 71.756 105.991 71.8067 107.831 71.7155C110.885 71.5535 113.17 70.2771 113.079 66.8736C112.988 63.5511 110.804 62.214 107.67 62.214C99.5907 62.2039 91.4007 61.4036 83.4533 62.4065C73.2411 63.6929 66.7598 58.2331 59.2473 51.5577C74.0196 51.5476 87.8618 51.5476 103.099 51.5476Z"
          className={styles.iconPath}
        />
      </g>
      <defs>
        <clipPath id="clip0_58_14672">
          <rect
            width="131"
            height="172"
            fill="white"
            transform="translate(0.5625 0.210938)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const AddBudgetModal = ({ setModal, editItem, setEditItem }) => {
  const [inputs, setInputs] = useState(
    editItem
      ? {
          category: editItem?.category,
          title: editItem?.title,
          budget: editItem?.total_budget,
        }
      : null
  );
  const dispatch = useDispatch();

  const Types = useSelector((state) => state.EventReducer.EventBudgetCat);

  const handleChange = (name, value) => {
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  // console.log("Types?.budgetCategories", Types);

  const { state } = useLocation();

  let vendors = [...state?.eventData?.vendors];

  useEffect(() => {
    dispatch(EventMiddleware.getBudgetCategory(state?.eventData?.id));
  }, []);

  const handleForm = () => {
    // console.log(inputs);
    if (inputs?.category?.val?.toLowerCase()?.includes("vendor")) {
      if (!inputs?.vendorName) {
        dispatch(
          showAlert({
            title: "createBudget",
            message: "Please add all budget details!",
            type: "Error",
          })
        );
        return;
      }
    }

    if (!inputs?.category || !inputs?.title || !inputs?.budget) {
      dispatch(
        showAlert({
          title: "createBudget",
          message: "Please add all budget details!",
          type: "Error",
        })
      );
    } else if (Math.sign(inputs?.budget) != 1) {
      dispatch(
        showAlert({
          title: "createBudget",
          message: "Please enter amount greater than 0",
          type: "Error",
        })
      );
    } else {
      if (editItem) {
        dispatch(
          EventMiddleware.updateBudget({
            id: editItem?.id,
            title: inputs?.title,
            amount: inputs?.budget,
          })
        )
          .then(() => {
            setEditItem(null);
            setModal(false);
          })
          .catch();
      } else {
        dispatch(
          EventMiddleware.createBudget({
            event_id: state?.eventData?.id,
            category_id: inputs?.category?.id,
            title: inputs?.title,
            amount: inputs?.budget,
            vendor_id: inputs?.category?.val?.toLowerCase()?.includes("vendor")
              ? inputs?.vendorName?.id
              : "",
          })
        )
          .then(() => setModal(false))
          .catch();
      }
    }
  };

  return (
    <Row className={styles.modalContentRow}>
      <Col xs={20} md={16}>
        <TextComponent textClass={styles.modalText}>
          {editItem ? "Edit" : "Add"} Budget
        </TextComponent>
        <Row className={styles.modalInputs}>
          {editItem ? (
            <></>
          ) : (
            <Dropdown
              label="Select Category"
              placeholder="Clothes"
              name="category"
              // options={[
              //   { value: "Clothes", option: "Clothes" },
              //   { value: "Food", option: "Food" },
              //   { value: "Decoration", option: "Decoration" },
              //   { value: "Vendors", option: "Vendors" },
              // ]}

              object={Types}
              stylesClass={styles.dropdown}
              onChange={(value) => {
                handleChange("category", value);
              }}
            />
          )}

          {/* {inputs?.category?.val?.toLowerCase()?.includes("vendor") && (
            <Dropdown
              label="Vendor Name"
              placeholder="Steve"
              name="vendorName"
              object={vendors}
              // options={vendors}
              // stylesClass={styles.dropdown}
              onChange={(value) => {
                handleChange("vendorName", value);
              }}
            />
          )} */}
          <InputField
            placeholder="Wedding Dress"
            name="title"
            label="Notes"
            value={inputs?.title ? inputs?.title : ""}
            onChange={(e) => {
              handleChange(e.target.name, e.target.value);
            }}
          />
          <InputField
            placeholder="$ 500"
            name="budget"
            label="Budget ($)"
            type="number"
            value={inputs?.budget ? inputs?.budget : ""}
            onChange={(e) => {
              handleChange(e.target.name, e.target.value);
            }}
          />
        </Row>
        <div className={styles.modalBtnContainer}>
          <SubmitButton
            title={editItem ? "Update" : "Create"}
            btnClass={styles.modalBtn}
            onClick={handleForm}
          />
        </div>
      </Col>
    </Row>
  );
};

const AddCategoryModal = ({ setModal, setCreateBudgetModal }) => {
  const [category, setCategory] = useState("");
  const dispatch = useDispatch();

  const { state } = useLocation();

  const handleForm = () => {
    if (!category) {
      dispatch(
        showAlert({
          title: "createBudget",
          message: "Please add category",
          type: "Error",
        })
      );
    } else {
      dispatch(
        EventMiddleware.createCategory({
          name: category,
          event_id: state?.eventData?.id,
        })
      )
        .then(() => {
          setModal(false);
          // setCreateBudgetModal(true);
        })
        .catch();
    }
  };

  return (
    <Row className={styles.modalContentRow}>
      <Col xs={20} md={16}>
        <TextComponent textClass={styles.modalText}>
          Add Budget Category
        </TextComponent>
        <Row className={styles.modalInputs}>
          <InputField
            placeholder="Enter Category Name"
            name="Category"
            label="Budget Category"
            value={category}
            onChange={(e) => {
              setCategory(e.target.value);
            }}
          />
        </Row>
        <div className={styles.modalBtnContainer}>
          <SubmitButton
            title="Create"
            btnClass={styles.modalBtn}
            onClick={handleForm}
          />
        </div>

        {/* <div className={styles.modalBtnContainer}>
          <SubmitButton
            title="Cancel"
            btnClass={styles.modalBtn}
            onClick={() => {
              setModal(false);
              // setCreateBudgetModal(true);
            }}
          />
        </div> */}
      </Col>
    </Row>
  );
};

// const TrackerModal = ({ inputs, handleChange, handleForm }) => {
//   return (
//     <Row className={styles.modalContentRow}>
//       <Col xs={23}>
//         <TextComponent textClass={styles.modalText}>Add Budget</TextComponent>
//         <Row className={styles.modalVendorInputs}>
//           <Col xs={24} lg={11}>
//             <Dropdown
//               label="Select Category"
//               placeholder="Clothes"
//               name="category"
//               options={[
//                 { value: "Clothes", option: "Clothes" },
//                 { value: "Food", option: "Food" },
//                 { value: "Decoration", option: "Decoration" },
//                 { value: "Vendors", option: "Vendors" },
//               ]}
//               selectedValue={inputs ? inputs["category"] : ""}
//               // selectedValue={inputs?.category}
//               stylesClass={styles.dropdown}
//               onChange={(value) => {
//                 console.log(value);
//                 handleChange("category", value);
//               }}
//             />
//           </Col>
//           <Col xs={24} lg={11}>
//             <Dropdown
//               label="Vendor Category"
//               placeholder="Select Vendor Category"
//               name="vendorCategory"
//               options={[
//                 { value: "Makeup Artist", option: "Makeup Artist" },
//                 { value: "Photographers", option: "Photographers" },
//                 { value: "Wedding DJs", option: "Wedding DJs" },
//               ]}
//               // selectedValue={inputs ? inputs[input.name] : ""}
//               // selectedValue={inputs?.category}
//               stylesClass={styles.dropdown}
//               onChange={(value) => {
//                 handleChange("VendorCategory", value);
//               }}
//             />
//           </Col>
//           <Col xs={24} lg={11}>
//             <Dropdown
//               label="Vendor Name"
//               placeholder="Maria Harry"
//               name="vendorName"
//               options={[
//                 { value: "Maria Harry", option: "Maria Harry" },
//                 { value: "James Steve", option: "James Steve" },
//               ]}
//               // selectedValue={inputs ? inputs[input.name] : ""}
//               // selectedValue={inputs?.category}
//               stylesClass={styles.dropdown}
//               onChange={(value) => {
//                 handleChange("vendorName", value);
//               }}
//             />
//           </Col>
//           <Col xs={24} lg={11}>
//             <InputField
//               placeholder="Wedding Dress"
//               name="title"
//               label="Budget Title"
//               // value={inputs ? inputs[input.name] : ""}
//               onChange={(e) => {
//                 handleChange(e.target.name, e.target.value);
//               }}
//             />
//           </Col>
//           <Col xs={24} lg={11}>
//             <InputField
//               placeholder="$ 500"
//               name="budget"
//               label="Budget ($)"
//               // value={inputs ? inputs[input.name] : ""}
//               onChange={(e) => {
//                 handleChange(e.target.name, e.target.value);
//               }}
//             />
//           </Col>
//         </Row>
//         <div className={styles.modalBtnContainer}>
//           <SubmitButton
//             title="Create"
//             btnClass={styles.modalBtn}
//             onClick={handleForm}
//           />
//         </div>
//       </Col>
//     </Row>
//   );
// };

const LeftCol = ({ loading }) => {
  const [budgetModalOpen, setBudgetModalOpen] = useState(false);
  const [editItem, setEditItem] = useState();
  const [categoryModal, setCategoryModal] = useState(false);
  const navigate = useNavigate();
  const Budget = useSelector((state) => state.EventReducer.EventBudget);
  const { state } = useLocation();
  // console.log("Budget", Budget);
  const dispatch = useDispatch();

  const onDelete = (id) => {
    dispatch(
      EventMiddleware.deleteBudget({
        id: id,
      })
    );
  };

  return (
    <Skeleton loading={loading}>
      <Row className={styles.leftColHeader}>
        <Col>
          <TextComponent textClass={styles.textCol}>
            Budget Tracker
          </TextComponent>
        </Col>
        <Col className={styles.btnCol}>
          <div style={{ display: "flex" }}>
            <SubmitButton
              title="Add Budget"
              btnClass={styles.headerBtn}
              onClick={() => setBudgetModalOpen(true)}
            />

            <SubmitButton
              title="Add Category"
              btnClass={styles.headerBtn}
              onClick={() => setCategoryModal(true)}
            />
          </div>
        </Col>
      </Row>
      <div className={styles.items}>
        {Budget?.tracker?.map((item) => (
          <Row
            key={item?.id}
            className={styles.itemRow}
            onClick={() => {
              navigate("/events/eventDetail/singleBudget", {
                state: {
                  headrTitle: "Budget",
                  data: { item, eventData: state?.eventData },
                },
              });
            }}
          >
            <Col
              xs={{ span: 24 }}
              sm={{ span: 16 }}
              md={{ span: 16 }}
              lg={{ span: 12 }}
            >
              <TextComponent textClass={styles.itemTitle}>
                {item?.category?.name}
              </TextComponent>
              <TextComponent textClass={styles.itemCategory}>
                {item?.title}
              </TextComponent>
              <TextComponent textClass={styles.budgetBreakup}>
                {`Budget: $${priceFormat(item?.total_budget)}`}
              </TextComponent>
              <TextComponent textClass={styles.budgetBreakup}>
                {`Actual Cost: $${
                  item?.actual_cost > 0 ? priceFormat(item?.actual_cost) : 0
                }`}
              </TextComponent>
            </Col>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 8 }}
              md={{ span: 8 }}
              lg={{ span: 12 }}
            >
              <TextComponent textClass={styles.budgetLeft}>
                <span className={styles.budgetLeftText}>Payment:</span>{" "}
                <span className={styles.totalBudget}>
                  {item?.paid < 0
                    ? "$" + priceFormat(item?.paid).replace("-", "")
                    : item?.paid > 0
                    ? "$" + priceFormat(item?.paid)
                    : "$0"}
                </span>
              </TextComponent>
              <TextComponent textClass={styles.budgetLeft}>
                <span className={styles.budgetLeftText}>Open Balance:</span>{" "}
                <span className={styles.totalBudget}>
                  {"$" + priceFormat(item?.actual_cost - item.paid)}
                </span>
              </TextComponent>
              <BiEdit
                size={25}
                className={styles.editIcon}
                onClick={(e) => {
                  e.stopPropagation();
                  setBudgetModalOpen(true);
                  setEditItem(item);
                }}
              />
              <MdDelete
                size={25}
                className={styles.editIcon}
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(item?.id);
                }}
              />
            </Col>
            <ProgressBar
              completed={item?.paid}
              className={styles.bar}
              maxCompleted={item?.total_budget}
              labelClassName={styles.labelBar}
              bgColor="var(--primary-color)"
              height="10px"
            />
          </Row>
        ))}
      </div>
      {budgetModalOpen && (
        <Modal
          isModalOpen={budgetModalOpen}
          setIsModalOpen={setBudgetModalOpen}
          closable={true}
          pinkBg={true}
          wideModal={true}
          onClose={() => setEditItem(null)}
          className={styles.addBudgetModal}
        >
          <AddBudgetModal
            setModal={setBudgetModalOpen}
            editItem={editItem}
            setEditItem={setEditItem}
          />
        </Modal>
      )}
      {categoryModal && (
        <Modal
          isModalOpen={categoryModal}
          setIsModalOpen={setCategoryModal}
          closable={true}
          pinkBg={true}
          wideModal={true}
          className={styles.addBudgetModal}
        >
          <AddCategoryModal
            setCreateBudgetModal={setBudgetModalOpen}
            setModal={setCategoryModal}
          />
        </Modal>
      )}
    </Skeleton>
  );
};

const RightCol = ({ loading }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const Budget = useSelector((state) => state.EventReducer.EventBudget);

  const budgetStats = [
    {
      title: "Actual Cost",
      value:
        Budget?.total_actual_cost > 0
          ? priceFormat(Budget?.total_actual_cost)
          : "0",
    },
    {
      title: "Payments",
      value:
        Budget?.paid < 0
          ? priceFormat(Budget?.paid).replace("-", "")
          : Budget?.paid > 0
          ? priceFormat(Budget?.paid)
          : "0",
    },
    {
      title: Budget?.unpaid < 0 ? "Over Budget" : "Under Budget",
      value:
        Budget?.unpaid < 0
          ? priceFormat(Budget?.unpaid).replace("-", "")
          : Budget?.unpaid > 0
          ? priceFormat(Budget?.unpaid)
          : "0",
    },
    {
      title: "Open Balance",
      value:
        Budget?.paid > 0
          ? Budget?.paid > Budget?.total_actual_cost
            ? "0"
            : priceFormat(Budget?.total_actual_cost - Budget?.paid)
          : "0",
    },
  ];
  return (
    <Skeleton loading={loading}>
      <WalletIcon />
      <TextComponent textClass={styles.rightColHeading}>
        Total Budget
        {/* {state?.eventData?.name} */}
      </TextComponent>
      <TextComponent textClass={styles.rightColPrice}>
        {"$" + priceFormat(Budget?.total_budget)}{" "}
      </TextComponent>
      {/* <TextComponent textClass={styles.smallText}>
        You can edit this at any time.
      </TextComponent> */}
      <SubmitButton
        title="Payment Tracker"
        outline={true}
        btnClass={styles.rightColBtn}
        onClick={() =>
          navigate("/events/budget/paymentTracking", {
            state: {
              headrTitle: "Payment Tracking",
              eventData: state?.eventData,
            },
          })
        }
      />
      <div className={styles.statsContainer}>
        {budgetStats.map((stat) => (
          <Row className={styles.statsRow}>
            <Col className={styles.rowTitle}>
              <TextComponent>{stat.title}</TextComponent>
            </Col>
            <Col className={styles.rowValue}>
              <TextComponent textClass={styles.rowText}>
                ${stat.value}
              </TextComponent>
            </Col>
          </Row>
        ))}
      </div>
    </Skeleton>
  );
};

const Budget = () => {
  const [loading, setloading] = useState(true);
  const dispatch = useDispatch();

  const { state } = useLocation();

  useEffect(() => {
    dispatch(
      EventMiddleware.budget({ event_id: state?.eventData?.id, name: "" })
    )
      .then(() => setloading(false))
      .catch(() => setloading(false));
  }, []);

  return (
    <Row className={styles.budgetContainer}>
      <>
        <Col xs={{ span: 24 }} lg={{ span: 13 }} xl={{ span: 14 }}>
          <LeftCol loading={loading} />
        </Col>
        <Col
          xs={{ span: 24 }}
          lg={{ span: 11 }}
          xl={{ span: 10 }}
          className={styles.rightCol}
        >
          <RightCol loading={loading} />
        </Col>
      </>
    </Row>
  );
};

export default Budget;
